import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/LegalPage.css';

function LegalPage() {
  return (
    <div>
      <Navbar />
      <main className="legal-page">
        <div className="legal-container">
          <h1>Mentions legales</h1>
          <p className="legal-updated">Derniere mise a jour: 1 avril 2026</p>

          <section>
            <h2>1. Editeur du site</h2>
            <p><strong>Nom:</strong> Ummah Elite Academy</p>
            <p><strong>Responsable de publication:</strong> A completer</p>
            <p><strong>Statut:</strong> A completer (auto-entreprise / societe)</p>
            <p><strong>Adresse:</strong> A completer</p>
            <p><strong>Email:</strong> eliteummah@gmail.com</p>
            <p><strong>SIREN / SIRET:</strong> A completer</p>
          </section>

          <section>
            <h2>2. Hebergement</h2>
            <p><strong>Hebergeur:</strong> Vercel</p>
          </section>

          <section id="donnees-personnelles">
            <h2>3. Donnees personnelles</h2>
            <p>
              Les informations transmises via le formulaire d'interet (email, formation
              d'interet) sont collectees afin de recontacter les personnes concernees au
              sujet des formations.
            </p>
            <p>
              Le formulaire est traite par Formspree (service tiers) via l'endpoint:
              https://formspree.io/f/xjgpwdkz
            </p>
            <p>
              Conformement au RGPD, vous pouvez demander l'acces, la rectification ou la
              suppression de vos donnees en ecrivant a: eliteummah@gmail.com
            </p>
          </section>

          <section id="cookies">
            <h2>4. Cookies</h2>
            <p>
              A la date du 1 avril 2026, le site n'utilise pas de solution de suivi
              d'audience ou publicitaire installee en propre (pas de pixel publicitaire,
              pas de script analytics dedie).
            </p>
            <p>
              Des cookies techniques peuvent toutefois etre deposes par des services tiers
              necessaires au fonctionnement de certaines fonctionnalites, notamment Formspree
              pour la soumission de formulaires.
            </p>
            <p>
              Vous pouvez configurer votre navigateur pour limiter ou refuser les cookies
              non essentiels.
            </p>
          </section>

          <section>
            <h2>5. Propriete intellectuelle</h2>
            <p>
              L'ensemble des contenus presents sur le site (textes, visuels, logo, structure)
              est protege par le droit d'auteur. Toute reproduction totale ou partielle sans
              autorisation prealable est interdite.
            </p>
          </section>

          <section>
            <h2>6. Responsabilite</h2>
            <p>
              L'editeur met tout en oeuvre pour fournir des informations fiables, mais ne peut
              garantir l'absence d'erreurs ou d'omissions. L'utilisateur reste responsable de
              l'usage qu'il fait des informations du site.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default LegalPage;
